import { useAuth } from "@/contexts/AuthContext";
import { useLifecycle, useResume } from "@/api/hooks/use-lifecycle";
import { formatTimestamp } from "@/lib/format";

/** Shown on every page while the Customer is Paused. */
export function PausedBanner() {
  const { user } = useAuth();
  const lifecycle = useLifecycle();
  const resume = useResume();

  if (lifecycle.data?.reason !== "paused") return null;

  return (
    <div
      data-testid="paused-banner"
      className="mb-6 flex flex-col gap-3 rounded-lg border border-amber-400/50 bg-amber-400/10 p-4 sm:flex-row sm:items-center sm:justify-between"
    >
      <div className="space-y-1 text-sm">
        <p className="font-medium text-fg">
          Optimization is paused since{" "}
          <span className="font-mono">{formatTimestamp(lifecycle.data.paused_since)}</span>.
        </p>
        <p className="text-fg-muted">
          Requests go to your provider exactly as sent. Nothing is optimized and no Savings fee is charged.
          {user?.role !== "admin" && " An admin can resume it in Settings."}
        </p>
      </div>
      {user?.role === "admin" && (
        <button
          type="button"
          onClick={() => resume.mutate()}
          disabled={resume.isPending}
          className="shrink-0 rounded-md bg-electric-blue px-4 py-2 text-sm font-medium text-white transition-colors hover:bg-electric-blue/90 disabled:opacity-40"
        >
          Resume
        </button>
      )}
    </div>
  );
}
